export default __webpack_public_path__ + "5e8c9665b6365f1e7076978e50766c77.png";